import * as React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './index.css';
import BrowserValidator from './components/BrowserValidator/BrowserValidator';
import { initSentry } from './integration/sentry';
import { ErrorFallback } from './pages/ErrorFallback/ErrorFallback';
import App from './pages/App/App';

initSentry();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={ErrorFallback}>
      <BrowserValidator>
        <App />
      </BrowserValidator>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);

serviceWorkerRegistration.register();
